<template>
    <div class="Inpage">
        <div class="Enrolment-personal">
            <!-- 姓名 -->
            <div class="per-line">
                <div class="flex flex-j-c-sb">
                    <span>姓名</span>
                    <input type="text" placeholder="请输入您的真实姓名" v-model="uname"/>
                </div>
            </div>
            <!-- 身份证 -->
            <div class="per-line">
                <div class="flex flex-j-c-sb flex-a-i-center">
                    <span>身份证</span>
                    <input type="text" placeholder="请输入您的身份证号码" v-model="uid" oninput="if(value.length > 18)value = value.slice(0, 18)" @blur.prevent="checkIdCard()"/>
                </div>
            </div>
            <!-- 手机号码 -->
            <div class="per-line">
                <div class="flex flex-j-c-sb">
                    <span>手机号码</span>
                    <input type="number" placeholder="请输入您的手机号码" v-model="uphone" class="text-yellow" oninput="if(value.length > 11)value = value.slice(0, 11)"/>
                </div>
            </div>
            <!-- 验证码 -->
            <div class="per-line">
                <div class="flex flex-j-c-sb">
                    <input type="text" placeholder="请输入您的验证码" v-model="ucheck" class="left" oninput="if(value.length > 6)value = value.slice(0, 6)"/>
                    <div class="btn-box">
                        <!-- <span class="check-btn">获取验证码</span> -->
                        <span class="check-btn" v-if="seconds < 60" style="color:#FABF01">{{seconds}}S</span>
                        <span class="check-btn" @click="getCode" v-else>获取验证码</span>
                    </div>
                </div>
            </div>
        </div>
        <mt-button @click.native="handleClick" size="large">提交信息</mt-button>

        <van-popup
          v-model="show"
          lock-scroll
          @closed='toMine'
          get-container="#app">
          <div class="pay-mask flex flex-j-c-center">
            <div class="mask-tips">
              <p class="mask-tips-title">上大学，到陈文卫教育</p>
              <p class="mask-tips-desc">审核已提交，请等待审核...</p>
            </div>
            <img :src="qrcode_url" style="width:2.50rem" class="mask-img"/>
            <p class="red">长按上方二维码</p>
            <p class="red">关注陈文卫成高服务号，开启招生事业！</p>
          </div>
        </van-popup>
    </div>
</template>

<script>
import { Toast, MessageBox } from 'mint-ui';
import { getMessage, applyAssistance, FuserMsg } from '@/api';
import { Popup } from 'vant';

export default {
    name: 'InvitationPage',
    components: {
    },
    data() {
      return {
        uname: '', // 姓名
        uphone: '', // 手机
        ucheck: '', // 验证码
        seconds: 61, // 验证码
        t: '', // timer
        type: '', // 申请类型
        pageData: {}, // 页面数据
        show: false,
        uid: '', // 身份证
        qrcode_url: require('@/assets/qrcodetype1.png')
      }
    },
    watch:{
    },
    created() {
      this.type = Number(this.$route.query.type);
      this.getUserMsg()
      /** ------------------------------------自动填充相关--------------------------------------------- */
      this.uname = localStorage.getItem('cww_FillInData') ? JSON.parse(localStorage.getItem('cww_FillInData')).pdName : '';
      this.uphone = localStorage.getItem('cww_FillInData') ? JSON.parse(localStorage.getItem('cww_FillInData')).pdPhone : '';
      /** ------------------------------------自动填充相关--------------------------------------------- */
    },
    methods: {
      // 获取用户信息
      getUserMsg() {
        FuserMsg().then(res => {
          if (res.code !== 0) { Toast({message: res.msg, className: 'iconfont icon-close', duration: 2000}); }
          this.pageData = res.data;
        })
      },
      // 获取验证码
      getCode() {
        if (!this._tools.checkPhone(this.uphone)) {
          Toast({message: '请输入正确的手机号码', className: 'iconfont icon-close'});
          return false;
        }
        if (this.seconds < 61) return
        this.seconds--;
        if (true) {
          this.requestCode();
        } else {
          console.log('error')
        }
      },
      // 获取短信验证码
      requestCode() {
        getMessage({content: this.uphone}).then(res => {
          if (res.code === 0) {
            MessageBox('提示', '验证码发送，请注意查收！');
            this.t = setInterval(() => {
              this.seconds--
              if (this.seconds === 0) {
                clearInterval(this.t)
                this.seconds = 61
              }
            }, 1000)
          } else {
            Toast({message: res.msg, className: 'iconfont icon-close'});
            this.seconds = 61;
          }
        })
      },
      // 检测身份证
      checkIdCard(){
        if (!this.uid) return false;
        if (!this._tools.checkIdentityLegal(this.uid)) {
          Toast({message: '请输入正确的身份证号码', className: 'iconfont icon-close'});
        }
      },
      // 提交信息
      handleClick() {
        // console.log(this._tools.checkPhone(this.uphone))
        let judge = true,
            params = {};
        if (!this.uname) {
          judge = false;
          Toast({message: '请输入您的名字', className: 'iconfont icon-close'});
          return false;
        } else {params.true_name = this.uname}

        if (!this.uid || !this._tools.checkIdentityLegal(this.uid)) {
          Toast({message: '请输入正确的身份证号码', className: 'iconfont icon-close'});
          judge = false;
          return false;
        } else {params.idcard = this.uid}

        if (!this._tools.checkPhone(this.uphone)) {
          judge = false;
          Toast({message: '请输入正确的手机号码', className: 'iconfont icon-close'});
          return false;
        } else {params.mobile = this.uphone}
        
        if (!this.ucheck) {
          judge = false;
          Toast({message: '请输入验证码', className: 'iconfont icon-close'});
          return false;
        } else {params.mobile_code = this.ucheck}
        params.user_id = this.$route.query.id
        params.type = Number(this.$route.query.type)
        if (judge) {
          // console.log(params)
          this.Submit(params)
        }
      },
      // 申请合伙人
      Submit(data) { 
        // if (this.pageData.level === 4 || this.pageData.level === 3 || (this.pageData.level === 2 && this.type === 1)) {
        //   let showMsg = `您已是${this.isLevel(this.pageData.level)}，无法申请成为${this.isPtype(this.type)}`;
        //   if ((this.pageData.level === 3 && this.type === 2) || (this.pageData.level === 2 && this.type === 1)) {
        //     showMsg = `您已是${this.isLevel(this.pageData.level)}，不能再次申请`
        //   }
        //   MessageBox('提示', showMsg);
        //   return false;
        // }
        if (this.pageData.level === 4 || this.pageData.level === 3) {
          let showMsg = `您已是${this.isLevel(this.pageData.level)}，无法申请成为${this.isPtype(this.type)}`;
          if ((this.pageData.level === 3 && this.type === 2)) {
            showMsg = `您已是${this.isLevel(this.pageData.level)}，不能再次申请`
          }
          MessageBox('提示', showMsg);
          return false;
        }
        if(this.pageData.level === 2 && this.type === 1){
          if(this.pageData.exist_invite == 1){
            let showMsg = `您已是${this.isLevel(this.pageData.level)}，并且已经邀请学生报读课程，不能再次申请`
            MessageBox('提示', showMsg);
            return false;
          }
        }
        applyAssistance(data).then(res => {
          if (res.code === 0) {
            if (data.type === 1) {
              this.qrcode_url = require('@/assets/qrcodetype1.png');
            } else if (data.type === 2){
              this.qrcode_url = require('@/assets/qrcodetype2.png');
            } else {
              this.qrcode_url = require('@/assets/qrcode0.jpg');
            }
            this.show=true;
            /** ------------------------------------自动填充相关--------------------------------------------- */
            if (localStorage.getItem('cww_FillInData')){
              let PT = JSON.parse(localStorage.getItem('cww_FillInData'));
              PT.pdName = this.uname;
              PT.pdPhone = this.uphone;
              localStorage.setItem('cww_FillInData', JSON.stringify(PT));
            } else {
              localStorage.setItem('cww_FillInData', JSON.stringify({'pdName' : this.uname, 'pdPhone' : this.uphone}));
            }
            /** ------------------------------------自动填充相关--------------------------------------------- */
          } else {
            MessageBox('提示', res.msg);
          }
        })
      },
      // 类型判断
      isPtype(num) {
        switch (Number(num)) {
          case 1:
            return '助理合伙人'
            break;
          case 2:
            return '招生合伙人'
            break;
          default:
            return '合伙人'
            break;
        }
      },
      // 等级判断
      isLevel(num) {
        switch (Number(num)) {
          case -1:
            return '潜在学员'
            break;
          case 1:
            return '普通学员'
            break;
          case 2:
            return '助理合伙人'
            break;
          case 3:
            return '招生合伙人'
            break;
          case 4:
            return '渠道负责人'
            break;
          default:
            return '潜在学员'
            break;
        }
      },
      // 跳转个人中心
      toMine() {
        this.$router.replace({name:'Mine'})
      }
    }
}

</script>
<style lang='less' scoped>
.Inpage{
    min-height: 100vh;
    font-size: 0.15rem;
    padding-top: 0.1rem;
    .Enrolment-personal{
        padding: 0.12rem 0.16rem 0;
        background-color: white;
        &>:last-child{
            border: none;
        }
    }
    .btn-box{
        position: relative;
        height: 0.5rem;
        width: 0.8rem;
        .check-btn{
            position: absolute;
            display: block;
            width: 0.8rem;
            height: 0.24rem;
            line-height: 0.24rem;
            background: #F6F6FA;
            color: #333333;
            font-size: 0.14rem;
            top: 50%;
            transform: translateY(-50%);
            border-radius: 0.12rem;
        }
    }
}
.van-popup--center{
    border-radius: 6px;
    width: 85%;
  }
  .mask-tips{
    background: #FABF01;
    color: white;
    padding: 0.2rem 0 0.1rem;
    .mask-tips-title{
      font-size: 0.2rem;
    }
  }
  .pay-mask{
    flex-direction: column;
    border-radius: 6px;
    padding-bottom: 0.1rem; 
    p{
      margin-bottom: 0.1rem;
    }
    .mask-img{
      margin: 0.05rem auto;
    }
  }
  .red{
    color: red;
    font-weight: bold;
  }
</style>